import { atom } from "@reatom/framework";
import { useAtom } from "@reatom/npm-react";

export const popoutAtom = atom<React.ReactNode>(null, "popoutAtom");
export const isPopoutOpenedAtom = atom((ctx) => {
  const value = ctx.spy(popoutAtom);
  if (value === null) return false;
  else return true;
}, "isPopoutOpenedAtom");

export function usePopout() {
  const [isPopoutOpened] = useAtom(isPopoutOpenedAtom);
  const [popout, setPopout] = useAtom(popoutAtom);

  function hide() {
    setPopout(null);
  }

  function set(newPopout: React.ReactNode) {
    setPopout(newPopout);
  }

  return {
    popout: popout,
    isOpened: isPopoutOpened,
    set: set,
    hide: hide,
  };
}
